<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    {{$t('news.template.opinion.changedByMemberSplit.p1')}}
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.changedByMemberSplit.p2')}}
    <router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[2] }}"
    >{{ news.textParams[3] }}
    </router-link>
    {{$t('news.template.opinion.changedByMemberSplit.p3')}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[4]}}">
      {{news.textParams[5]}}
    </router-link>.
    {{$t('news.template.opinion.changedByMemberSplit.p4')}}
    {{ news.textParams[6] }}
    {{$t('news.template.opinion.changedByMemberSplit.p5')}}
  </div>
</template>
